import React from "react"
import { Link } from "gatsby"

import "../scss/components/categoryList.scss"

function CategoryList() {
  return (
		<div className="catWrap">
			<h3>Categories</h3>
			<ul className="catList">
				<li>
					<Link className="Dev" to="/categories/dev">Dev</Link>
				</li>
				<li>
					<Link className="Travel" to="/categories/travel">Travel</Link>
				</li>
				<li>
					<Link className="Lifestyle" to="/categories/lifestyle">LifeStyle</Link>
				</li>
				<li>
					<Link className="Design" to="/categories/design">Design</Link>
				</li>
        <li>
					<Link className="Others" to="/categories/other">Others</Link>
				</li>
			</ul>
		</div>
  )
}

export default CategoryList
